import React, { FC } from "react";
import { MdOutlineFormatColorText as TextColorIcon } from "react-icons/md";
import { useMediaQuery } from "react-responsive";
import { Editor } from "@tiptap/react";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { ColorButton } from "./ToolbarButtons/ColorButton";
import { BLACK_BASE } from "./constants/colors";
import { Tooltip } from "../Tooltip";
import { Button } from "../Button";
import { ButtonVariants } from "../Button/types";

interface Props {
  editor: Editor;
  colors: string[];
}

export const ColorsTooltip: FC<Props> = ({ editor, colors }) => {
  const isGLScreenBreakpoint = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS.GL,
  });

  const isActive = (color: string) => editor.isActive("textStyle", { color });
  const getActiveColor = () => editor.getAttributes("textStyle").color;

  const onClickColorButton = (color: string) => () => {
    const newColor = isActive(color) ? BLACK_BASE : color;
    editor.chain().focus().setColor(newColor).run();
  };

  return (
    <Tooltip
      position={isGLScreenBreakpoint ? "left" : "top"}
      content={
        <div className="flex items-center justify-start gap-2">
          {colors.map((color) => (
            <ColorButton
              key={color}
              color={color}
              isActive={isActive(color)}
              onClick={onClickColorButton(color)}
            />
          ))}
        </div>
      }
    >
      <Button
        type="button"
        variant={ButtonVariants.SECONDARY}
        className="!rounded-md !duration-100 !p-1 "
      >
        <TextColorIcon
          title="text color"
          className="w-5 h-5 transition-none !brightness-110"
          style={{ color: getActiveColor() || BLACK_BASE }}
        />
      </Button>
    </Tooltip>
  );
};
